var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFnWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_10044)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28125 0H12.7188C13.5883 0.00240528 14.4215 0.34888 15.0363 0.963713C15.6511 1.57855 15.9976 2.41175 16 3.28125V12.7188C15.9976 13.5883 15.6511 14.4215 15.0363 15.0363C14.4215 15.6511 13.5883 15.9976 12.7188 16H3.28125C2.41175 15.9976 1.57855 15.6511 0.963713 15.0363C0.34888 14.4215 0.00240528 13.5883 0 12.7188L0 3.28125C0.00240528 2.41175 0.34888 1.57855 0.963713 0.963713C1.57855 0.34888 2.41175 0.00240528 3.28125 0Z",
    fill: "#29A71A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1735_10044)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5417 4.45833C10.6042 3.52083 9.33333 3 8 3C5.25417 3 3 5.25417 3 8C3 8.87917 3.27083 9.7125 3.70833 10.4667L3 13L5.6375 12.3542C6.36667 12.7542 7.16667 13 8 13C10.7458 13 13 10.7458 13 8C13 6.67083 12.4833 5.4 11.5417 4.45833ZM8 12.1667C7.25833 12.1667 6.55 11.9208 5.9125 11.5458L5.7625 11.4542L4.19583 11.8667L4.6125 10.3375L4.5125 10.1792C4.1 9.52083 3.83333 8.78333 3.83333 8C3.83333 5.71667 5.71667 3.83333 8 3.83333C9.10417 3.83333 10.1667 4.27083 10.95 5.05417C11.7333 5.8375 12.1667 6.89583 12.1667 8C12.1667 10.2833 10.2792 12.1667 8 12.1667ZM10.2917 9.02083C10.1667 8.95833 9.55417 8.65833 9.44167 8.61667C9.32917 8.575 9.24583 8.55417 9.1625 8.67917C9.07917 8.80417 8.84167 9.08333 8.76667 9.16667C8.69583 9.25 8.62083 9.25833 8.49583 9.19583C8.37083 9.13333 7.97083 9.00417 7.49583 8.57917C7.125 8.25 6.875 7.84167 6.80417 7.71667C6.73333 7.59167 6.79583 7.525 6.85833 7.4625C6.9125 7.40833 6.98333 7.31667 7.04583 7.24583C7.10833 7.175 7.12917 7.12083 7.17083 7.0375C7.2125 6.95417 7.19167 6.88333 7.1625 6.82083C7.12917 6.75833 6.87917 6.14583 6.775 5.89583C6.675 5.65417 6.57083 5.6875 6.49583 5.68333C6.425 5.67917 6.34167 5.67917 6.25833 5.67917C6.175 5.67917 6.04167 5.7125 5.925 5.83333C5.8125 5.95833 5.49167 6.2625 5.49167 6.875C5.49167 7.4875 5.9375 8.07917 6 8.1625C6.0625 8.24583 6.87917 9.50417 8.125 10.0417C8.42083 10.1708 8.65417 10.2458 8.83333 10.3042C9.13333 10.4 9.40417 10.3875 9.61667 10.3542C9.85417 10.3167 10.3542 10.0542 10.4583 9.7625C10.5625 9.47083 10.5625 9.22083 10.5292 9.17083C10.5 9.11667 10.4167 9.08333 10.2917 9.02083Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_10044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1735_10044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnWhatsapp);
export default __webpack_public_path__ + "static/media/fn-whatsapp.f1022c51d6d7ffd42ecdd863fd8ee9cf.svg";
export { ForwardRef as ReactComponent };